/** @format */

import {ReactNode, useState} from 'react';

import {Root, Hover} from './styles';

interface Props {
  children: ReactNode;
  color: string;
  disabled?: boolean;
}

const HoverBox = ({children, color, disabled}: Props) => {
  const [hover, setHover] = useState<boolean>(false);

  return (
    <Root onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <Hover hover={hover && !disabled} color={color} />
      {children}
    </Root>
  );
};

export {HoverBox};
